import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IceEntity, IIceEntity } from '../../models/core/IceEntity';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../icepanel/icepanelcontainer.component';
import { IcecontrolSettings, IcepanelSettings } from '../models/icesettings';

export class IcepanelDialogData extends IceEntity {
  headerCtrl: IcecontrolSettings = null;
  record: IceEntity = null;
  parentrecord: any = null;
  panel: IcepanelSettings = null;
  constructor(rec: IceEntity, parRec: any, pnl: IcepanelSettings) {
    super();
    this.record = rec
    this.parentrecord = parRec
    this.panel = pnl;
  }
}

@Component({
  selector: 'icepaneldialog',
  templateUrl: 'icepaneldialog.html',
  providers: [IcepanelComponent, IcepanelContainerComponent]
})
export class IcepanelDialog {
  constructor(
    public dialogRef: MatDialogRef<IcepanelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: IIceEntity) {
  }

  onHeaderClick(event) {
    switch (event.type) {
      case "submit":
        if (this.dialogRef.componentInstance != null && this.dialogRef.componentInstance.data != null) {
          let panel: IcepanelSettings = <IcepanelSettings>this.dialogRef.componentInstance.data["panel"];
          if (panel != null) {
            let form = panel.getForm();
            if (form != null && form.valid == false) {
              return;
            }
          }
          this.dialogRef.componentInstance.data["headerCtrl"] = event.headerCtrl;
        }
        this.dialogRef.close(this.dialogRef.componentInstance);
        break;
      default: {
        if (this.dialogRef.componentInstance != null && this.dialogRef.componentInstance.data != null) {
          this.dialogRef.componentInstance.data["headerCtrl"] = event.headerCtrl;
          let hdrCtrl: IcecontrolSettings = event.headerCtrl;
          if (hdrCtrl != null && hdrCtrl.getClickControlEvent() != null) {
            event["componentInstance"] = this.dialogRef.componentInstance;
            // emit to control observers
            hdrCtrl.getClickControlEvent().emit(event);
            break;
          }
        }

        this.dialogRef.close(this.dialogRef.componentInstance);
        break;
      }
    }
  }
}
